var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v(_vm._s(_vm.appTitle))]),_c('p',[_vm._v("by Goeland Dev Team")]),_c('p',[_vm._v("City of Lausanne - Switzerland")])])}
var staticRenderFns = []

export { render, staticRenderFns }